// extracted by mini-css-extract-plugin
export default {"detailsContainer":"PokemonDetails_detailsContainer__A-4pG"};